import React from 'react';
import { compose, pure } from 'recompose';
import _ from 'lodash';
import { withStyles } from '@material-ui/core/styles';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableRow from '@material-ui/core/TableRow';
import CheckOkButton from '../atoms/CheckOkButton';
import CheckNgButton from '../atoms/CheckNgButton';
import CheckInvalidButton from '../atoms/CheckInvalidButton';
import RemoveStripeTextButton from '../atoms/RemoveStripeTextButton';

const styles = {
  textGroup: {
    whiteSpace: 'pre-wrap'
  }
};

const enhance = compose(pure);

const ReleaseTableBody = enhance(
  ({
    shops,
    classes,
    emptyRows,
    page,
    rowsPerPage,
    shopRedirectAction,
    menuRedirectAction,
    identityRedirectAction,
    removeStripeAction,
    order,
    orderBy
  }) => {
    let sortedResult;
    if (orderBy === 'streetAddress') {
      sortedResult = _.orderBy(
        shops,
        ['prefectures', 'city', 'address', 'building'],
        [order, order, order, order]
      );
    } else {
      sortedResult = _.orderBy(shops, orderBy, order);
    }
    return (
      <TableBody>
        {sortedResult
          .slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
          .map(shop => {
            const key = `${shop.shopId}-${shop.groupId}`;
            const params = {
              id: shop.shopId
            };

            return (
              <TableRow key={key}>
                <TableCell>{shop.registeredAt}</TableCell>
                <TableCell>{shop.shopId}</TableCell>
                <TableCell>{shop.groupName}</TableCell>
                <TableCell>{shop.shopName}</TableCell>
                <TableCell>
                  {shop.prefectures}
                  {` `}
                  {shop.city}
                  {` `}
                  {shop.address}
                  {` `}
                  {shop.building}
                </TableCell>
                <TableCell>
                  {shop.accountStatus.shop && (
                    <CheckOkButton
                      id={shop.shopId}
                      onClickAction={shopRedirectAction}
                    />
                  )}
                  {!shop.accountStatus.shop && (
                    <CheckNgButton
                      id={shop.shopId}
                      onClickAction={shopRedirectAction}
                    />
                  )}
                </TableCell>
                <TableCell>
                  {shop.accountStatus.menu && (
                    <CheckOkButton
                      id={shop.shopId}
                      onClickAction={menuRedirectAction}
                    />
                  )}
                  {!shop.accountStatus.menu && (
                    <CheckNgButton
                      id={shop.shopId}
                      onClickAction={menuRedirectAction}
                    />
                  )}
                </TableCell>
                <TableCell>
                  {shop.accountStatus.identity && (
                    <CheckOkButton
                      id={shop.shopId}
                      onClickAction={identityRedirectAction}
                    />
                  )}
                  {!shop.accountStatus.identity && (
                    <CheckNgButton
                      id={shop.shopId}
                      onClickAction={identityRedirectAction}
                    />
                  )}
                </TableCell>

                <TableCell>
                  {shop.paymentGroupType === 'STRIPE' ? (
                    <>
                      {shop.paymentGroupAccount ? (
                        <>
                          <CheckOkButton />
                          {shop.paymentGroupName && (
                            <div className={classes.textGroup}>
                              {`(${shop.paymentGroupName})`}
                            </div>
                          )}
                        </>
                      ) : (
                        <>
                          <CheckNgButton />
                          {shop.paymentGroupName && (
                            <div className={classes.textGroup}>
                              {`(${shop.paymentGroupName})`}
                            </div>
                          )}
                        </>
                      )}
                    </>
                  ) : (
                    <>
                      {shop.depositManage === 'SELF' &&
                        shop.accountStatus.stripeAccount && <CheckOkButton />}
                      {shop.depositManage === 'SELF' &&
                        !shop.accountStatus.stripeAccount && <CheckNgButton />}
                      {shop.depositManage !== 'SELF' && <CheckInvalidButton />}
                    </>
                  )}
                </TableCell>
                <TableCell>
                  {shop.paymentGroupType === 'BANK' ? (
                    <>
                      {shop.paymentGroupAccount ? (
                        <>
                          <CheckOkButton />
                          {shop.paymentGroupName && (
                            <div className={classes.textGroup}>
                              {`(${shop.paymentGroupName})`}
                            </div>
                          )}
                        </>
                      ) : (
                        <>
                          <CheckNgButton />
                          {shop.paymentGroupName && (
                            <div className={classes.textGroup}>
                              {`(${shop.paymentGroupName})`}
                            </div>
                          )}
                        </>
                      )}
                    </>
                  ) : (
                    <>
                      {shop.depositManage === 'NONSELF' && <CheckOkButton />}
                      {shop.depositManage !== 'NONSELF' && <CheckNgButton />}
                    </>
                  )}
                </TableCell>
                <TableCell>
                  {shop.depositManage === 'SELF' &&
                    shop.accountStatus.stripeAccount &&
                    !shop.stripeGroupId && (
                      <RemoveStripeTextButton
                        params={params}
                        onClickAction={removeStripeAction}
                      />
                    )}
                </TableCell>
                <TableCell>
                  {shop.status === 'AVAILABLE' && '利用可能'}
                  {shop.status === 'PRE_AVAILABLE' && '準備中'}
                  {shop.status === 'UNREGISTER' && '未登録'}
                  {shop.status === 'SUSPENDED' && '利用停止中'}
                  {shop.status === 'CLOSED' && '閉店'}
                </TableCell>
              </TableRow>
            );
          })}
        {emptyRows > 0 && (
          <TableRow style={{ height: 49 * emptyRows }}>
            <TableCell colSpan={7} />
          </TableRow>
        )}
      </TableBody>
    );
  }
);

export default withStyles(styles)(ReleaseTableBody);
